<template>
  <div id="">
    <div class="emd-stripe">
      <div class="emd-bounds">
        <div class="emd-section fade-in">
          <div v-if="isLoading && !requestFailed" class="emd-box _state_loading"></div>
          <p v-else-if="!isLoading && requestFailed" class="emd-text _color_danger _align_center">{{$t('edit.error')}}</p>
          <div v-else>
            <div class="emd-form-group">
              <label class="emd-label ">Buscar Permissões</label>
              <input class="emd-input " type="text" placeholder="Permissões" v-model="queryPermissions" />
            </div>
            <div class="emd-box">
              <EmdBoxHeader :title="$t('breadcrumb.edit.permissions')">
                <button class="emd-btn _color_secondary _type_text" v-show="disabled" @click="disabled = !disabled">{{$t('edit.edit')}}</button>
              </EmdBoxHeader>
              <form action="javascript:void(0)" ref="formPermissions" @submit.prevent="savePermissions" novalidate="true">
                <table class="emd-table">
                  <thead>
                    <tr>
                      <th class="emd-text _style_label _size_tiny">{{$t('edit.form.permissions.events')}}</th>
                      <th class="emd-text _style_label _size_tiny"> {{$t('edit.form.permissions.status')}} </th>
                      <th class="emd-text _style_label _size_tiny"> {{$t('edit.form.permissions.required')}} </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(evt, index) in (filteredEvents || allEvents)" :key="index">
                      <td data-label="Eventos" class="emd-text _size_small">{{evt.description}}</td>
                      <td data-label="Status">
                        <input class="emd-switcher _color_success" type="checkbox" :value="evt.value" :id="`eventSwitch${index}Status`" :disabled="disabled" v-model="optionalEvents"/>
                        <label class="emd-switcher__label" :for="`eventSwitch${index}Status`">{{$t('edit.form.permissions.active')}}</label>
                      </td>
                      <td data-label="Obrigatório">
                        <input @change="checkRequiredEventToSend(evt.description, evt.value)" class="emd-switcher _color_info" type="checkbox" :id="`eventSwitch${index}Required`" :value="evt.value" :disabled="disabled" v-model="events"/>
                        <label class="emd-switcher__label" :for="`eventSwitch${index}Required`">{{$t('edit.form.permissions.active')}}</label>
                      </td>
                    </tr>
                  </tbody>
                  <thead>
                    <tr>
                      <th class="emd-text _style_label _size_tiny"> {{$t('edit.form.permissions.actions')}} </th>
                      <th class="emd-text _style_label _size_tiny"> {{$t('edit.form.permissions.status')}}</th>
                      <th class="emd-text _style_label _size_tiny"> {{$t('edit.form.permissions.required')}} </th>
                    </tr>
                  </thead>
                  <tbody>
                      <tr v-for="(action, index) in (filteredActions || allActions)" :key="index">
                        <td data-label="Ações" class="emd-text _size_small">{{action.description}}</td>
                        <td data-label="Status">
                          <input class="emd-switcher _color_success" type="checkbox" :value="action.value" :disabled="disabled" :id="`actionSwitch${index}Status`" v-model="optionalActions"/>
                          <label class="emd-switcher__label" :for="`actionSwitch${index}Status`">{{$t('edit.form.permissions.active')}}</label>
                        </td>
                        <td data-label="Obrigatório">
                          <input @change="checkRequiredEventToSend(action.description, action.value)" class="emd-switcher _color_info" type="checkbox" :id="`actionSwitch${index}Required`" :value="action.value" :disabled="disabled" v-model="actions"/>
                          <label class="emd-switcher__label" :for="`actionSwitch${index}Required`">{{$t('edit.form.permissions.active')}}</label>
                        </td>
                      </tr>
                  </tbody>
                </table>
                <div class="emd-box__content">
                  <div class="emd-alert _color_success hideFeedback" ref="feedback">
                    <p>{{$t('edit.form.permissions.success_message')}}</p>
                  </div>
                  <error-list :items="errors"></error-list>
                  <div class="emd-flex _justify_flex-end" v-show="!disabled">
                    <div class="emd-flex-item _shrink">
                      <button class="emd-btn _color_primary _type_text" type="button" @click="disabled = !disabled">{{$t('edit.cancel')}}</button>
                    </div>
                    <div class="emd-flex-item _shrink">
                      <button class="emd-btn _color_secondary" type="submit">{{$t('edit.save')}}</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ErrorList from '@/components/project/ErrorList.vue'
import EmdBoxHeader from '@/components/emerald/EmdBoxHeader'
import form from '@/plugins/form.js'
import sendFsCustomEvent from '@/mixins/sendFsCustomEvent'

export default {
  name: 'ApplicationPermissions',
  components: {
    ErrorList,
    EmdBoxHeader
  },
  mixins: [sendFsCustomEvent],
  computed: {
    isLoading () {
      return this.$store.state.application.detail.isLoading
    },
    requestFailed () {
      return this.$store.state.application.detail.requestFailed
    },
    allEvents: {
      get () {
        return this.$store.state.application.events
      },
      set (value) {
        this.filteredEvents = value
      }
    },
    allActions: {
      get () {
        return this.$store.state.application.actions
      },
      set (value) {
        this.filteredActions = value
      }
    },
    events: {
      get () {
        if (this.body.events === undefined) {
          this.body.events = this.$store.state.application.detail.events
        }
        return this.body.events
      },
      set (value) {
        value.filter(reqEvent => {
          const hasEventAtOptional = this.optionalEvents.includes(reqEvent)
          if (!hasEventAtOptional) {
            this.optionalEvents.push(reqEvent)
          }
          return hasEventAtOptional
        })
        this.body.events = value
      }
    },
    actions: {
      get () {
        if (this.body.actions === undefined) {
          this.body.actions = this.$store.state.application.detail.actions
        }
        return this.body.actions
      },
      set (value) {
        value.filter(reqAction => {
          const hasActionAtOptional = this.optionalActions.includes(reqAction)
          if (!hasActionAtOptional) {
            this.optionalActions.push(reqAction)
          }
          return hasActionAtOptional
        })
        this.body.actions = value
      }
    },
    optionalEvents: {
      get () {
        if (this.body.optional_events === undefined) {
          this.body.optional_events = this.$store.getters.getEventsStatus()
        }
        return this.body.optional_events
      },
      set (value) {
        const events = this.events.filter(reqEvent => value.includes(reqEvent))
        this.events = events
        this.body.optional_events = value
      }
    },
    optionalActions: {
      get () {
        if (this.body.optional_actions === undefined) {
          this.body.optional_actions = this.$store.getters.getActionsStatus()
        }
        return this.body.optional_actions
      },
      set (value) {
        const actions = this.actions.filter(reqAction => value.includes(reqAction))
        this.actions = actions
        this.body.optional_actions = value
      }
    }
  },
  data () {
    return {
      body: {
        events: undefined,
        actions: undefined,
        optional_actions: undefined,
        optional_events: undefined
      },
      status: {
        events: undefined,
        actions: undefined
      },
      queryPermissions: '',
      filteredEvents: undefined,
      filteredActions: undefined,
      disabled: true,
      errors: [],
      form: form
    }
  },
  methods: {
    displayFeedback () {
      this.$refs.feedback.classList.add('displayFeedback')
      this.$refs.feedback.classList.remove('hideFeedback')
      setTimeout(() => {
        this.$refs.feedback.classList.remove('displayFeedback')
        this.$refs.feedback.classList.add('hideFeedback')
      }, 2000)
    },
    savePermissions (e) {
      const elements = [...e.target.elements]
      const invalidElements = elements.filter(element => element.willValidate).filter(element => !element.checkValidity())
      if (invalidElements.length === 0) {
        const submitButton = elements.filter(e => e.type === 'submit')[0]
        submitButton.classList.add('_state_loading')
        const events = Object.assign([], this.body.events)
        const actions = Object.assign([], this.body.actions)
        const optionalEvents = this.body.optional_events.filter(optEvent => !events.includes(optEvent))
        const optionalActions = this.body.optional_actions.filter(optAction => !actions.includes(optAction))
        const body = {
          events,
          actions,
          optional_events: optionalEvents,
          optional_actions: optionalActions
        }
        this.$store.dispatch('UPDATE_PERMISSIONS', body)
          .then(response => {
            this.errors = []
            this.disabled = true
            this.displayFeedback()
            submitButton.classList.remove('_state_loading')
          })
          .catch(response => {
            submitButton.classList.remove('_state_loading')
            if (response.status === 400) {
              this.errors = response.body.errors
            }
          })
      } else {
        invalidElements[0].focus()
      }
    },
    checkRequiredEventToSend (fieldName, value) {
      const appEventName = value ? 'permissão-obrigatoria' : 'permissão-opcional'
      this.sendFsEvent(appEventName, { permissionName: fieldName })
    }
  },
  watch: {
    queryPermissions: function (query) {
      this.allEvents = this.allEvents.filter(e => {
        const name = e.description.toLowerCase()
        return name.indexOf(query.toLowerCase()) >= 0
      })
      this.allActions = this.allActions.filter(e => {
        const name = e.description.toLowerCase()
        return name.indexOf(query.toLowerCase()) >= 0
      })
    }
  }
}
</script>
<style scoped>
  .emd-box._state_loading {
    height: 300px;
    background-repeat: no-repeat;
    background-image:
      linear-gradient(#f4f4f4),
      linear-gradient(#f4f4f4),
      linear-gradient(#f4f4f4),
      linear-gradient(#f4f4f4),
      linear-gradient(#f4f4f4),
      linear-gradient(#f4f4f4),
      linear-gradient(#f4f4f4),
      linear-gradient(#f4f4f4),
      linear-gradient(#f4f4f4),
      linear-gradient(#f4f4f4),
      linear-gradient(#f4f4f4),
      linear-gradient(#f4f4f4),
      linear-gradient(#f4f4f4);
    background-size:
      15% 25px,
      35% 30px,
      10% 30px,
      10% 30px,
      35% 30px,
      10% 30px,
      10% 30px,
      35% 30px,
      10% 30px,
      10% 30px,
      35% 30px,
      10% 30px,
      10% 30px;
    background-position:
      1.59% 9.35%,
      1.59% 35%,
      67.59% 35%,
      85.59% 35%,
      1.59% 50%,
      67.59% 50%,
      85.59% 50%,
      1.59% 65%,
      67.59% 65%,
      85.59% 65%,
      1.59% 80%,
      67.59% 80%,
      85.59% 80%;
    opacity: 1;
    animation: opacity 1s infinite ease-in;
  }
</style>
